import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c59783a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gradient" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "text text-xl md:text-xl lg:text-3xl xl:text-4xl"
}
const _hoisted_3 = { class: "uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "header-item font-montserrat-bold",
    style: _normalizeStyle({ backgroundImage: `url(${_ctx.item.images.header})` })
  }, [
    _hoisted_1,
    (_ctx.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(`${_ctx.playNow}`), 1),
          _createTextVNode(" " + _toDisplayString(`${_ctx.item.title}`), 1)
        ]))
      : _createCommentVNode("", true)
  ], 4))
}